<template>
  <Loader :position="'center'" v-if="isLoading" />
  <div v-else>
    <div>
      <Question
        v-for="(question, index) in questionsList"
        :key="question.id"
        :question="question"
        :number="++index"
      />
    </div>

    <div v-if="noQuestionsFound" class="noQuestions">
      <h3 class>No questions found.</h3>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Question from "./Question";
import Loader from "./Loader";

export default {
  name: "QuestionsList",
  components: {
    Question,
    Loader,
  },
  beforeUpdate() {
    this.createCompletedList();
  },
  methods: {
    ...mapActions([
      "createCompletedList",
      "fetchQuestions",
      "updateSortDifficulty",
    ]),
  },
  computed: {
    ...mapGetters([
      "getQuestions",
      "getSortDifficulty",
      "getSortQuery",
      "getSortType",
    ]),
    questionsList() {
      //Sorting by type
      let sorted = this.getQuestions;
      if (this.getSortType) {
        sorted = sorted.filter((item) => item.isChallenge);
      }
      // Sorting by difficulty
      sorted =
        this.getSortDifficulty.length > 0
          ? sorted?.filter((question) =>
              this.getSortDifficulty.includes(question.difficulty)
            )
          : sorted;
      // Filtering by search query
      if (this.getSortQuery) {
        sorted = sorted.filter((q) =>
          q.question.toLowerCase().includes(this.getSortQuery.toLowerCase())
        );
      }

      return sorted;
    },
    isLoading() {
      return Boolean(!this.questionsList);
    },
    noQuestionsFound() {
      if (this.questionsList && this.questionsList.length === 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.noQuestions {
  margin: 50px auto 0;
  h3 {
    text-align: center;
    font-weight: 400;
    color: $color-grey;
  }
}
</style>
